import React from "react";
import TableTiemposReq from "../../components/TiemposReq/TableTiemposReq/TableTiemposReq";

const TiemposReq = (props) => {
  return <TableTiemposReq />;
};

export default TiemposReq;
